<template>
	<div class="tab-pane" :id="id">
		<div role="form" class="col-12 col-lg-12">
			<div class="row m-0 pt-4">
				<div class="col-md-12 ">
					<div v-for="(element,index) in assessment.test" v-bind:key="index" class="form-group">
                        <div class="row">
                        <div class="mi-content col-md-12">
                        <div class="card card-body" v-html="assessment.test[index]">{{}}</div>
                        <br>
						<div v-if="assessment.student_notes[index]==true" class="icon h3" v-tippy title="This section will display in the student resources."><i class="fas fa-info-circle"></i></div>
						<RichText v-if="!forPreview"
							:text.sync="assessment.test_responses[index]"
							:initial="originalDesc[index]"
							:options="{ height: 140 }"
							:refresh="refresh"
							class="border"
						></RichText>
						<RichText v-if="forPreview"
							text.sync=""
							initial=""
							:options="{ height: 140 }"
							:refresh="refresh"
							class="border"
						></RichText>
                        </div>


                        </div>


					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button1 {
  background-color: white; 
  color:  #4CAF50; 
  border: 2px solid #4CAF50;
}

.button1:hover {
  background-color: #4CAF50;
  color: white;
}

.mi-content
{

   width: 1080px; /* or whatever width you want. */
   max-width:100%; /* or whatever width you want. */
   display: inline-block;

}
.icon{position:absolute;right:10px;top:-10px}

</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";

import AssessmentService from "@/services/AssessmentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
	name: "TestViewer",

	props: ["id", "assessment", "defaultTab", "valid","forPreview"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		ConfigItemSearch,
		RichText,
		draggable
	},

	data() {
		return {
			fs: fs,
            ntests : 0,
			originalDesc: [],
			refresh: null,
			// forPreview:true,
			dirty: false,
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {

	},

	created() {
		if(!this.forPreview){
			if(this.assessment.test_responses){
				for(let element of this.assessment.test_responses ){
					this.originalDesc.push(element)
				}
				this.ntests = this.assessment.test.length
			}
			else{
				this.assessment.test = []
				this.ntests = 0
			}
		}
		else {
			if(this.assessment.test){
				for(let element of this.assessment.test ){
					this.originalDesc.push(element)
				}
				this.ntests = this.assessment.test.length
			}

		}


    },

	watch: {
        assessment(newVal){
            console.log("TEST CHANGED ")
        }

	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		Initial(index){
			return this.assessment.test_responses[index]
		},
		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"assessment",
				(newc, old) => {
					this.dirty = true;
				},
				{ deep: true }
			);
		},


		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/TestViewer.vue